import { useEffect, useState, useRef } from 'react'
import { createConsumer } from '@rails/actioncable'

let consumer = null

function getConsumer() {
  if (!consumer) {
    consumer = createConsumer('/cable')
  }
  return consumer
}

/**
 * Drop-in replacement for useFaye — uses ActionCable + AnyCable-Go
 * @param {string} fiscodex - Competition ID (e.g. "12345")
 * @param {function} onMessage - Callback when data is received
 * @returns {{ connected: boolean, error: string|null }}
 */
export const useActionCable = (fiscodex, onMessage) => {
  const [connected, setConnected] = useState(false)
  const [error, setError] = useState(null)
  const subscriptionRef = useRef(null)
  const onMessageRef = useRef(onMessage)

  // Keep ref up-to-date without triggering re-subscribe
  useEffect(() => {
    onMessageRef.current = onMessage
  }, [onMessage])

  useEffect(() => {
    if (!fiscodex) return

    const subscription = getConsumer().subscriptions.create(
      { channel: 'CompetitionChannel', fiscodex },
      {
        connected() {
          setConnected(true)
          setError(null)
        },
        disconnected() {
          setConnected(false)
        },
        rejected() {
          setError('Subscription rejected')
          setConnected(false)
        },
        received(data) {
          onMessageRef.current?.(data)
        }
      }
    )

    subscriptionRef.current = subscription

    return () => {
      subscription.unsubscribe()
      subscriptionRef.current = null
    }
  }, [fiscodex])

  return { connected, error }
}
